import { useQuery } from '@tanstack/react-query';
import { fetchStreetAddress } from '@/features/mapbox/services/geocode.service';

/** The street at a pin. Cached: the coordinate does not grow a new address. */
export function usePlaceAddress(longitude: number, latitude: number) {
  return useQuery({
    queryKey: ['place-address', longitude, latitude],
    queryFn: () => fetchStreetAddress(longitude, latitude),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
